module.exports = __webpack_public_path__ + "img/galeria-acuariofilia-7.60b8478e.jpg";